<template>
  <div class="learning_page">
    <div class="topic-img"></div>
    <div class="top-nav filter">
      <div class="container clearfix">
        <div class="filter-list">
          <span class="category">类别：</span>
          <el-radio-group v-model="pid" @input="(params) => { fiflterHandle1(params, 'pid') }">
            <el-radio-button
              v-for="(item, index) of classifyList"
              :key="index"
              :label="item.id"
              >{{ item.title }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="filter-list" 
          @mouseenter="getHeight"
          @mouseleave="fullHeight = 34"
          :style="{ height: fullHeight + 'px' }">
          <span class="category" v-html="judgeText"></span>
          <el-radio-group v-model="direction" ref="qwcontent" @input="(params) => { fiflterHandle1(params, 'direction') }">
            <el-radio-button
              v-for="(item, index) of directionList"
              :key="index"
              :label="item.id"
              >{{ item.title }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="filter-list" v-if="judgeShow">
          <span class="category">分类：</span>
          <el-radio-group v-model="easy_id" @input="(params) => { fiflterHandle1(params, 'easy_id') }">
            <el-radio-button
              v-for="(item, index) of fenlei"
              :key="index"
              :label="item.id"
              >{{ item.title }}</el-radio-button
            >
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="main-container ptb40">
      <div class="section container relative">
        <div class="text-right mb20">
          <span v-for="(sort, index) of sortAll" :key="index" :class="[judgeActive == index ? 'active' : '']">
            <span>{{ sort.name }}</span>
            <span class="caret-wrapper">
              <i
                v-for="value of sort.children"
                :key="value"
                :class="['sort-caret', { active: isSort == value }]"
                @click="sortHandle(value)"
              ></i>
            </span>
          </span>
        </div>
        <CourseList :courseList="courseLists" :type="'learning'" v-loading="loading">
          <template v-slot:course="slotProps">
            <div
              class="text-primary"
              :style="{ color: slotProps.data == '0.00' ? 'red' : '' }"
            >
              {{ slotProps.data == "0.00" && slotProps.type == '5' ? "价格请见详情" : slotProps.data == "0.00" && slotProps.type != '5' ? "免费" : `￥${slotProps.data}` }}
            </div>
          </template>
        </CourseList>
        <Page
          :total="total"
          :pageSize="pageSize"
          :pageIndex="pageIndex"
          @changePage="handlePage"
          class="page-new mt24"
          v-if="total > 10"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CourseList from "./../components/public/courseList";
import Page from "./../components/public/page";
import { getcateListApi, getcourseListNewApi } from '@/api/api'
export default {
  name: 'learning',
  data () {
    return {
      classifyList: [],
      directionList: [],
      fenlei: [],
      navList: [],
      tagList: {},
      courseLists: [],
      fullHeight: '',
      pid:'',
      direction: '',
      easy_id: '',
      pageSize: 8,
      pageIndex: 1,
      isSort: '0',
      sortAll: [
        //排序
        {
          name: "上架时间",
          children: ["1", "2"],
        },
        {
          name: "销量",
          children: ["3", "4"],
        },
        {
          name: "价格",
          children: ["5", "6"],
        },
      ],
      total: 0,
      loading: true,
      form:{pid: '', direction: '', easy_id:''  }
    }
  },
  components: { CourseList, Page },
  created () {
    this.getNavList()
    if (this.$route.query.pid) {
      this.pid = this.$route.query.pid;
      this.direction = this.$route.query.direction;
      this.easy_id = this.$route.query.esy_cate_id;
    }
    this.GetcourseList()
  },
  computed: {
    // 判断分类显示与否
    judgeShow() {
      const filterObj = this.classifyList.length && this.classifyList[1].child.filter(item => { if (item.id == this.direction) { return item } })
      if (this.direction !== '' && (this.tagList[this.pid] == '岗位'|| !this.tagList[this.pid]) && filterObj.length) {
        return true
      }
      return false
    },
    judgeText() {
      const filterObj = this.classifyList.length && this.classifyList[2].child.filter(item => { if (item.id == this.direction) { return item } })
      const filterObjOne = this.classifyList.length && this.classifyList[3].child.filter(item => { if (item.id == this.direction) { return item } })
      if (this.tagList[this.pid]) {
        return this.tagList[this.pid] + '：'
      } else if (this.direction != ''){
        if (filterObj.length) {
          return '分类：'
        } else if (filterObjOne.length) {
          return '机构：'
        } else {
          return '岗位：'
        }
      }
      return '岗位：'
      
    },
    judgeActive () {
      const findIndex = this.sortAll.findIndex(item => { return item.children.findIndex(ite => ite == this.isSort) > -1 })
      console.log(findIndex)
      return findIndex
    }
  },
  methods: {
    GetcourseList() {
      //获取课程列表
      const params = {
        pid: this.pid,
        direction: this.direction,
        esy_id: this.easy_id,
        order: this.isSort,
        limit: this.pageSize,
        page: this.pageIndex,
        lang: localStorage.getItem("lang"),
      };
      getcourseListNewApi(params)
          .then((res) => {
            if (res.data.code == 0) {
              const data = res.data.data;
              this.courseLists = data.course_list.list;
              this.total = data.course_list.total;
              this.loading = false;
            } else {
              this.$message.warning(res.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
    },
    async getNavList () {
      const res = await getcateListApi()
      console.log(res)
      if (res.data.code == 0) {
        const resp = res.data.data
        this.navList = resp.cate.map(item => { return item })
        this.navList.forEach(item => {
          this.tagList[`${item.id}`] = item.title === '非认证课程' ? '方向' : item.title === '合作专区' ? '机构' : '岗位'
        })
        console.log(this.tagList)
        this.classifyList = this.filterData(resp.cate, [], 'top')
        this.directionList = this.classifyList[0].child
        console.log(this.classifyList)
      }
    },
    // 数据整形，将nav,添加全部选项，并且，child为所有
    filterData (data, oneArray, flag) {
      oneArray.push({id: '', title: '全部',child: [], flag: flag })
      data.forEach(item => {
        const obj = {id: item.id, pid: item.pid, title: item.title }
        oneArray[0].pid = item.pid
        if (item.child && item.child.length > 0) {
          obj.child = [];
          if (flag == 'top') {
            oneArray[0].child[0] = {id: '', title: '全部' }
            oneArray[0].child[0].pid = item.pid
            oneArray[0].child = this.removeDuplicateObj(oneArray[0].child.concat(this.filterData(item.child, obj.child, 'seconds')))
            console.log('top')
            console.log(item.child)
            console.log(oneArray[0])
          } else {
            oneArray[0].child = this.filterData(item.child, obj.child, 'seconds')
          }
        }
        oneArray.push(obj)
      });
      return oneArray
    },
    // 数据去重
    removeDuplicateObj (arr) {
      let obj = {};
      arr = arr.reduce((newArr, next) => {
        obj[next.id] ? "" : (obj[next.id] = true && newArr.push(next));
        return newArr;
      }, []);
      return arr;
    },
    //动态获取高度
    getHeight() {
      this.fullHeight = this.$refs.qwcontent.$el.offsetHeight;
    },
    // 删选分类切换，清空下级分类数据，请求数据
    fiflterHandle1 (params, name) {
      console.log(params)
      if (name == 'pid') {
        const filterObj = this.classifyList.filter(item => { if (item.id == params) { return item }  })
        this.directionList = filterObj[0].child
        this.direction = ''
        this.easy_id = ''
      }
      if (name == 'direction') {
        const filterObj = this.directionList.filter(item => { if (item.id == params) { return item }  })
        this.fenlei = filterObj[0].child
        this.easy_id = ''
      }
      this.GetcourseList()
      console.log(name)
    },
    //获取当前页码
    handlePage(i) {
      this.pageIndex = i;
      this.GetcourseList();
    },
    // 排序点击
    sortHandle(val) {
      this.isSort = val;
      this.GetcourseList();
    },
  }
}
</script>
<style lang="scss" scoped>
.topic-img {
  background: url("./../assets/image/StudyBanner.png") no-repeat top center;
  width: 100%;
  height: 320px;
}
.filter {
  min-height: 280px;
  background: #fff;
  padding: 36px 0 4px;
  box-shadow: 4px 2px 5px #ebebeb;
}
.category {
  float: left;
  margin-top: 9px;
  margin-right: 10px;
  font-size: 16px;
  font-weight: bold;
}
.ptb40 {
  padding: 40px 0;
}
.main-container {
  background: #f5f5f5 url('../assets/image/bg.png') no-repeat center center;
  background-size: 100% 100%;
}
.filter-list {
  margin: 20px;
  height: 34px;
  overflow: hidden;
  transition: height 0.5s;
}
>>> .el-radio-button {
  margin: 0 5px;
}
>>> .el-radio-group {
  width: 94%;
}
>>> .el-radio-button__inner {
  border: none;
  padding: 10px 10px;
}
>>> .el-radio-button:first-child .el-radio-button__inner {
  border: none;
  border-radius: 0;
}
>>> .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0;
}
>>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #4165ff;
  border-color: #4165ff;
  box-shadow: -1px 0 0 0 #4165ff;
}
>>> .is-active .el-radio-button__inner:hover {
  color: #fff;
}
>>> .el-radio-button__inner:hover {
  color: #4165ff;
}
.text-right {
  >span {
    &:after {
      content: '';
      display: inline;
      border-right: 1px solid #ddd;
      margin-left:2px;
    }
    &:last-child{
      &:after {
        display: none;
      }
    }
    &:hover, &.active {
      color:#4165ff;
    }
    margin-right: 10px;
  }
}
.caret-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 34px;
  width: 24px;
  vertical-align: middle;
  cursor: pointer;
  overflow: initial;
  position: relative;
}
.caret-wrapper .sort-caret {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  position: absolute;
  left: 7px;
}
.caret-wrapper .sort-caret:first-child {
  border-bottom-color: #c0c4cc;
  top: 5px;
}
.caret-wrapper .sort-caret:last-child {
  border-top-color: #c0c4cc;
  bottom: 7px;
}
.caret-wrapper .sort-caret.active:first-child {
  border-bottom-color: #333;
}
.caret-wrapper .sort-caret.active:last-child {
  border-top-color: #333;
}
.page-new {
  position: relative;
}
.page-new >>> .el-pagination {
  text-align: center;
  position: relative;
  left: 0;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/learning.vue